import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span
                                                    className="heading">A STEP-BY-STEP GUIDE TO GAINING BUY-IN</span>
                                            </div>
                                            <div className="border_subtitle">Step 1: Build your case</div>
                                            <p>Once you have your idea, consider how it might translate in
                                                reality. Gather facts and information to both support it and
                                                demonstrate that you have researched staff surveys, company
                                                policies or spoken to others in the organisation to establish
                                                how it would ‘fit’ or bring measurable benefit. Just theorising
                                                and second guessing will only get you tied in knots at the first
                                                detailed analysis by someone else.</p>
                                            <p>We will deal with how to build your case and win commitment from
                                                potential stakeholders in a later section. For now you need to
                                                think about how you will create a solid foundation for your
                                                idea.</p>
                                            <div className="border_subtitle">Step 2: Identify your audience
                                            </div>
                                            <p>Think about these questions to establish whether you’ve
                                                identified the right people to talk to:</p>


                                            <div className="lightgreencontentbg keyquestionpad ">
                                                <ul className="greenbullet-list">

                                                    <li>Why is it necessary to gain commitment from this
                                                        stakeholder?
                                                    </li>
                                                    <li className="zeroPaddingUl4">What benefit will their
                                                        commitment bring?
                                                    </li>

                                                </ul>

                                            </div>
                                            <p>Remember, you may have many stakeholders, each with different
                                                agendas. Identifying your target
                                                audience will help you to pitch your idea at the right level,
                                                capture their interest, gain their
                                                understanding and achieve buy-in.</p>
                                            <p>Those with decision making authority may have different concerns
                                                and priorities. Taking the time
                                                to find out what these are will help you present your idea in a
                                                way which captures their interest
                                                and therefore is more likely to win their commitment. Try to
                                                anticipate the kind of questions you’ll
                                                be asked by those with different roles and perspectives. You
                                                could also bolster the idea’s
                                                feasibility by suggesting support from tried and tested external
                                                sources, which may help to ease
                                                any concerns about possible associated risks.</p>
                                            <div className="border_subtitle">Step 3: Present your vision</div>
                                            <p>People think in stories and narratives more than facts and
                                                figures. A large part of being a great
                                                orator and gaining buy-in is being able to weave an engaging
                                                vision for the future outcome of this
                                                activity. Leadership effectiveness has been found to have strong
                                                correlations with the ability to
                                                present a clear and inspirational vision to subordinate workers.<a
                                                    className="superscripttext supLinesapce"
                                                    href="further_info.php?course=300"><sup>3</sup></a></p>
                                            <p>Further information on presenting your vision is given in a later
                                                section.</p>

                                            <div className="border_subtitle">Step 4: Establish partnerships
                                            </div>
                                            <p>Identify the tasks you need to delegate and to whom, to sustain
                                                progress. Be flexible about how
                                                they might fit these tasks in amongst their existing
                                                responsibilities and explain the benefits to
                                                them of contributing to the project.</p>
                                            <div className="border_subtitle">Step 5: Get agreement to the deal
                                            </div>
                                            <p>If yours is a long-term project, present it as a series of
                                                recognisable, achievable stages and agree
                                                a practical timescale for each with the appropriate decision
                                                makers. Referring to decisions you
                                                already have agreement for will help secure others and, as you
                                                proceed, this will make it easier
                                                to increase buy-in to the overall project and boost momentum
                                                generally.</p>
                                            <div className="border_subtitle">Step 6: Deliver</div>
                                            <p>Making sure each stage of the project happens on time will be
                                                easier if you’ve followed the
                                                advice above, and established who is responsible for different
                                                contributions. If things seem to be
                                                working according to plan and on time it will maintain people’s
                                                interest and commitment.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page4')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}